module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "main-container clearfix"
  }, [_c('div', {
    staticClass: "form-wrapper clearfix"
  }, [_c('form', {
    staticClass: "form-custom",
    attrs: {
      "novalidate": "novalidate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loginHandle($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-success': (_vm.checkPhone != null) && _vm.checkPhone, 'has-error': (_vm.checkPhone != null) && !_vm.checkPhone
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "maxlength": "11",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "blur": _vm.validatePhone,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkPhone != null),
      expression: "checkPhone != null"
    }],
    staticClass: "glyphicon form-control-feedback",
    class: {
      'glyphicon-ok': _vm.checkPhone, 'glyphicon-remove': !_vm.checkPhone
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.phoneMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-success': (_vm.checkPassword != null) && _vm.checkPassword, 'has-error': (_vm.checkPassword != null) && !_vm.checkPassword
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("密码")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "请输入6-16位数字字母的组合"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": _vm.validatePassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkPassword != null),
      expression: "checkPassword != null"
    }],
    staticClass: "glyphicon form-control-feedback",
    class: {
      'glyphicon-ok': _vm.checkPassword, 'glyphicon-remove': !_vm.checkPassword
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.passwordMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group capt-box has-feedback",
    class: {
      'has-success': (_vm.checkCapt != null) && _vm.checkCapt, 'has-error': (_vm.checkCapt != null) && !_vm.checkCapt
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.capt),
      expression: "capt"
    }],
    staticClass: "form-control input-capt",
    attrs: {
      "type": "text",
      "maxlength": "4",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.capt)
    },
    on: {
      "blur": _vm.validateCapt,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.capt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkCapt != null),
      expression: "checkCapt != null"
    }],
    staticClass: "glyphicon form-control-feedback",
    class: {
      'glyphicon-ok': _vm.checkCapt, 'glyphicon-remove': !_vm.checkCapt
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.captMsg))]), _vm._v(" "), _c('div', {
    staticClass: "capt"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;",
      "title": "点击更换验证码"
    },
    on: {
      "click": _vm.updateCapt
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.captUrl
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group btn-wrap"
  }, [_c('p', {
    staticClass: "err-wrap"
  }, [_c('span', [_vm._v(_vm._s(_vm.errmsg))]), _vm._v(" ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "forget-pass"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toFindPass
    }
  }, [_vm._v("忘记密码？")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-about-me"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("北京伟嘉安捷投资担保有限公司成立于2006年3月15日。是一家为个人提供房产按揭引荐服务、房产权证服务的专业机构，注册资金为5000万元。")]), _vm._v(" "), _c('div', {
    staticClass: "register-box"
  }, [_c('button', {
    staticClass: "register-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toRegister
    }
  }, [_vm._v("注册新账号"), _c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("登录"), _c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copy"
  }, [_vm._v("\n      © 2017 "), _c('span', [_vm._v("北京伟嘉安捷投资担保有限公司")]), _vm._v(" All rights reserved   |   京ICP备16040229号-2\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-13665b85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/login.vue
// module id = 583
// module chunks = 1